module.exports = __webpack_public_path__ + "media/tr_tr_s3_Filiz.edf27022.oga";